<template>
  <v-dialog v-model="show" :max-width="800" :fullscreen="$vuetify.breakpoint.xsOnly" transition="dialog-bottom-transition" scrollable>
    <v-card :class="{ 'rounded-xl': !$vuetify.breakpoint.xsOnly }" elevation="10" class="d-flex flex-column">
      <v-card-title class="pa-4 primary white--text d-flex justify-space-between align-center">
        <span class="text-h6 font-weight-bold">Nueva Productora/Empresa</span>
        <v-btn icon dark @click="show = false" v-if="$vuetify.breakpoint.xsOnly">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-6 bg-app">
        <v-container>
          <v-form ref="formUser">
            <v-row>
              <v-col cols="12" class="pb-0">
                <span class="primary--text font-weight-bold">
                  Información del contacto
                </span>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="pb-0">
                <v-text-field
                  label="Productora/Empresa"
                  background-color="white"
                  outlined
                  v-model="form.companyName"
                  clearable
                  dense
                  :rules="validation()"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="pb-0">
                <v-autocomplete
                  label="Distribuidor"
                  background-color="white"
                  outlined
                  v-model="distributor"
                  clearable
                  :items="distributors"
                  item-text="companyName"
                  dense
                  return-object
                  :rules="validation()"
                  class="rounded-lg"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="pb-0" v-if="distributor">
                <v-autocomplete
                  label="Zona"
                  background-color="white"
                  outlined
                  v-model="zone"
                  clearable
                  :items="zones"
                  item-text="name"
                  dense
                  return-object
                  class="rounded-lg"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="pb-0">
                <v-text-field
                  label="Nombre contacto"
                  background-color="white"
                  outlined
                  :rules="validation('nombre')"
                  v-model="form.name"
                  clearable
                  dense
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="pb-0">
                <v-text-field
                  label="Correo"
                  background-color="white"
                  v-model="form.email"
                  :rules="emailValidations"
                  outlined
                  clearable
                  type="email"
                  dense
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="pb-0">
                <v-text-field
                  label="Teléfono"
                  v-model="form.phone"
                  background-color="white"
                  type="phone"
                  outlined
                  clearable
                  dense
                  :rules="validationPhone('telefono')"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="pb-0">
                <v-text-field
                  label="RFC"
                  v-model="form.tin"
                  @keyup="uppercase"
                  background-color="white"
                  outlined
                  clearable
                  dense
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-6">
                <span class="primary--text font-weight-bold">
                  Domicilio
                </span>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="pb-0">
                <v-text-field
                  label="Calle"
                  background-color="white"
                  outlined
                  v-model="form.street"
                  clearable
                  dense
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="pb-0">
                <v-text-field
                  label="Código postal"
                  background-color="white"
                  outlined
                  v-model="zipCode"
                  clearable
                  dense
                  type="number"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="3" md="3" class="pb-0">
                <v-text-field
                  label="N.ext"
                  background-color="white"
                  outlined
                  v-model="form.n_ext"
                  clearable
                  dense
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="3" md="3" class="pb-0">
                <v-text-field
                  label="N.int"
                  background-color="white"
                  v-model="form.n_int"
                  outlined
                  clearable
                  dense
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="pb-0">
                <v-combobox
                  label="Colonia"
                  background-color="white"
                  outlined
                  clearable
                  dense
                  v-model="suburb"
                  return-object
                  item-text="name"
                  :items="countryList"
                  hide-no-data
                  class="rounded-lg"
                ></v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="pb-0">
                <v-text-field
                  label="Ciudad"
                  v-model="form.country"
                  background-color="white"
                  outlined
                  clearable
                  dense
                  :rules="validation('ciudad')"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="pb-0">
                <v-text-field
                  label="Estado"
                  background-color="white"
                  v-model="form.state"
                  outlined
                  clearable
                  dense
                  :rules="validation('estado')"
                  class="rounded-lg"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4 bg-white">
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          text
          @click="show = false"
          :disabled="isLoading"
          class="px-4"
        >
          Cancelar
        </v-btn>
        <v-btn color="primary" rounded @click="add" :loading="isLoading" elevation="0" class="px-8">
          Crear
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//Vuex
import { mapActions, mapState, mapMutations } from "vuex";
//validation
import {
  requiredValidation,
  phoneValidation,
  emailValidation,
} from "@/helpers/validations.js";
export default {
  data: () => ({
    isLoading: false,
    zipCode: "",
    suburb: "",
    countryList: [],
    zones: [],
    form: {
      name: "",
      email: "",
      phone: "",
      tin: "",
      companyName: "",
      street: "",
      n_ext: "",
      n_int: "",
      country: "",
      state: "",
    },
    distributor: null,
    zone: null,
    zones: [],
    distributors: [],
    emailValidations: emailValidation(),
    user: JSON.parse(localStorage.getItem("user")),
  }),
  props: {
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("organization", ["addDistributor"]),
    ...mapActions("zone", ["getZonesByDistributor"]),
    ...mapActions("user", ["getDistributors"]),
    validation(name) {
      return requiredValidation(name);
    },
    validationPhone(name) {
      return phoneValidation(name);
    },
    uppercase() {
      this.form.tin = this.form.tin.toUpperCase();
    },
    async add() {
      try {
        if (this.$refs.formUser.validate()) {
          this.isLoading = true;
          let auxSuburb = null;
          if (this.suburb) {
            if (typeof this.suburb === "string") {
              auxSuburb = this.suburb;
            } else if (typeof this.suburb === "object") {
              auxSuburb = this.suburb.name;
            }
          }

          let payload = {
            billingInformation: {
              taxId: this.form.tin || "",
              companyName: this.form.companyName,
            },
            companyName: this.form.name,
            phone: this.form.phone,
            email: this.form.email,
            address: {
              city: this.form.country,
              exteriorNumber: this.form.n_ext || "",
              interiorNumber: this.form.n_int || "",
              state: this.form.state,
              street: this.form.street || "",
              suburb: auxSuburb || "",
              zipCode: this.zipCode || "",
            },
            companyType: "ORG_COMMERCIAL",
            emails: [],
            distributor: this.distributor._id,
            sampler: this.user._id,
          };
          if (this.zone) {
            payload.zone = this.zone._id;
          }
          let response = await this.addDistributor(payload);
          if (!response) throw response;
          this.$emit("fetchData");
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Productira/Empresa creada",
            timeout: 5000,
          });
          this.show = false;
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al crear usuario",
          timeout: 5000,
        });
      }
      this.isLoading = false;
    },
    async getZones() {
      try {
        let payload = {
          distributorId: this.distributor._id,
        };
        let response = await this.getZonesByDistributor(payload);
        if (!response) throw response;
        this.zones = response.zones;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al cargar zonas",
          timeout: 5000,
        });
      }
    },
    async fetchDistributors() {
      try {
        let response = await this.getDistributors();
        if (!response) throw response;
        this.distributors = response.distributors;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal cargar distribuidores",
          timeout: 5000,
        });
      }
    },
  },
  async created() {
    await this.fetchDistributors();
  },
  watch: {
    async distributor(value) {
      if (!value) return;
      await this.getZones();
    },
  },
};
</script>
